import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import Gallery from "./gallery";
import Slidebar from "./slidebar";
import EnlargedImage from "./enlargedImage";
import VimeoModal from "./modal/vimeoModal";
import Explanation from "./explanation";
import Color from "./color";
import Size from "./size";
import Submit from "./submit";
import Accordion from "./accordion";
import Favorite from "./favorite";
import Selector from "./selector";
import Stickypin from "~/js/common/stickypin";
import Tooltip from "~/js/common/tooltip";
// import HoverImage from "./hoverImage";
import CardName from "./cardName";
import Tabs from "./tabs";
import SizeGuideModal from "./modal/sizeGuideModal";
import SizeChart from "./sizeChart";
import ContactModal from "./modal/contactModal";
import ArrivalNotificationModal from "./modal/arrivalNotificationModal";
import CartNotification from "./modal/miniCartModal";
import HeaderMenu from "./headerMenu";
import GlobalUsersModal from "../account/modal/globalUsersModal";
import ProductRecommendations from "./productRecommend";
export default class Products {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      }
    });

    if (
      navigator.userAgent.indexOf("iPhone") > 0 ||
      navigator.userAgent.indexOf("iPod") > 0 ||
      navigator.userAgent.indexOf("iPad") > 0 ||
      navigator.userAgent.indexOf("Android") > 0 ||
      (/android|ipod|ipad|iphone|macintosh/.test(navigator.userAgent.toLowerCase()) && "ontouchend" in document)
    ) {
      store.dispatch("setIsSP", {
        sta: true
      });
    }

    this.header = new Header();
    this.footer = new Footer();
    this.gallery = new Gallery();
    this.slidebar = new Slidebar();
    this.enlargedImage = new EnlargedImage();
    this.vimeoModal = new VimeoModal();
    this.explanation = new Explanation();
    this.color = new Color();
    this.size = new Size();
    this.submit = new Submit();
    this.sizeChart = new Accordion(document.querySelector("._sizeChart"));
    const sizeChartPanel = document.getElementById("panel-size-chart");
    this.sizeChartUnit = new SizeChart(sizeChartPanel, {
      toggleHost: sizeChartPanel && sizeChartPanel.querySelector("._sizeChartFoot"),
    });
    this.sizeGuideUnit = new SizeChart(document.querySelector("._size_guide_modal ._contents"));
    this.productInfo = new Accordion(document.querySelector("._productInfo"));
    this.productHandling = new Accordion(document.querySelector("._productHandling"));
    this.notes = new Accordion(document.querySelector("._notes"));
    // this.favorite = new Favorite(document.querySelector(".products-storeitems"));
    // this.hoverImage = new HoverImage(document.querySelector('.products-storeitems'));
    this.cardName = new CardName(document.querySelector(".products-storeitems ._list0"));
    this.cardName = new CardName(document.querySelector(".products-storeitems ._list1"));
    this.cardName = new CardName(document.querySelector(".products-storeitems ._list2"));
    this.cardName = new CardName(document.querySelector(".products-storeitems ._list3"));
    this.tabs = new Tabs();
    this.sizeGuideModal = new SizeGuideModal();
    this.contactModal = new ContactModal();
    this.arrivalNotificationModal = new ArrivalNotificationModal();
    customElements.define('cart-notification', CartNotification);
    this.headerMenu = new HeaderMenu();
    this.selector = new Selector();
    this.stickyPin = new Stickypin();
    this.tooltip = new Tooltip();
    this.globalUsersModal = new GlobalUsersModal();
    this.ProductRecommendations = new ProductRecommendations();

    store.dispatch("init");
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
    Common.setupScrollY();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new Products();
});
